import {
    // FILE_UPLOAD,
    CREATE_ADMIN_NOTIFICATION_SETTINGS,
    RETRIEVE_ADMIN_NOTIFICATION_SETTINGS,
    // RETRIEVE_ARCHITECTURECOMPANYCONVERTEDLEADS,
    // RETRIEVE_ARCHITECTURECOMPANYPENDINGLEADS,
    RETRIEVESINGLE_ADMIN_NOTIFICATION_SETTINGS,
    UPDATE_ADMIN_NOTIFICATION_SETTINGS,
    DELETE_ADMIN_NOTIFICATION_SETTINGS,
    // RETRIEVE_ARCHITECTURESERVERSTAFF,
    // RETRIEVE_ARCHITECTURESERVERSERVICEUSERS,
} from "./type";
import AdminNotificationSettings from "../service/AdminNotificationSettings";
// export const fileUpload = (data) => async (dispatch) => {
//   try {
//     const res = await AdminNotificationSettings.fileUpload(data);
//     dispatch({
//       type: FILE_UPLOAD,
//       payload: res.data.data,
//     });
//     return Promise.resolve(res.data);
//   } catch (err) {
//     return Promise.reject(err);
//   }
// };
export const create = (data) => async (dispatch) => {
    try {
        const res = await AdminNotificationSettings.create(data);
        dispatch({
            type: CREATE_ADMIN_NOTIFICATION_SETTINGS,
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
export const retrieve = (data) => async (dispatch) => {
    try {
        const res = await AdminNotificationSettings.fetchList(data);
        dispatch({
            type: RETRIEVE_ADMIN_NOTIFICATION_SETTINGS,
            status: '',
            response: {},
            payload: res.data.data,
        });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const retrieveSingle = (data) => async (dispatch) => {
    try {
        const res = await AdminNotificationSettings.fetchSingle(data);
        // dispatch({
        //     type: RETRIEVESINGLE_ADMIN_NOTIFICATION_SETTINGS,
        //     status: '',
        //     response: {},
        //     payload: res.data.data,
        // });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const update = (data) => async (dispatch) => {
    try {
        const res = await AdminNotificationSettings.update(data);
        dispatch({
            type: UPDATE_ADMIN_NOTIFICATION_SETTINGS,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
// export const changeStatus = (data) => async (dispatch) => {
//     try {
//         const res = await AdminNotificationSettings.changeStatus(data);
//         dispatch({
//             type: UPDATE_ADMIN_NOTIFICATION_SETTINGS,
//             status: '',
//             response: {},
//             payload: res.data,
//         });
//         return Promise.resolve(res.data);
//     } catch (err) {
//         return Promise.reject(err);
//     }
// };
export const trash = (data) => async (dispatch) => {
    try {
        const res = await AdminNotificationSettings.trash(data);
        dispatch({
            type: DELETE_ADMIN_NOTIFICATION_SETTINGS,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};